import PropTypes from 'prop-types';
import React from 'react';
import FormSelect from '@homeaway/react-form-select';
import "./FlagDropdown.css";
/* istanbul ignore next */

var noop = function noop() {};

function FlagDropdown(_ref) {
  var countryCode = _ref.countryCode,
      id = _ref.id,
      items = _ref.items,
      labels = _ref.labels,
      onChange = _ref.onChange,
      phoneCode = _ref.phoneCode;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormSelect, {
    id: id,
    className: "InputTel__select",
    name: id,
    items: items,
    label: labels.countryCode,
    value: countryCode,
    onChange: onChange
  }), /*#__PURE__*/React.createElement("span", {
    className: "InputTel__phone-code"
  }, "+" + phoneCode));
}

FlagDropdown.propTypes = {
  countryCode: PropTypes.string,
  id: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })),
  labels: PropTypes.shape({
    phoneNumber: PropTypes.string,
    countryCode: PropTypes.string
  }),
  onChange: PropTypes.func,
  phoneCode: PropTypes.string
};
FlagDropdown.defaultProps = {
  flagData: [],
  onChange: noop
};
export default FlagDropdown;
//# sourceMappingURL=FlagDropdown.js.map